(function () {
  'use strict';
  if (window.__nbnMetaOrderAttributionLoaded) return;
  window.__nbnMetaOrderAttributionLoaded = true;

  var STORE = 'nbn_meta_order_attribution_v1';
  var SENT = STORE + '_sent';
  var UTM = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  var PAID_MEDIUMS = ['cpc', 'ppc', 'paid', 'paid_social', 'paidsocial', 'social_paid'];
  var PAID_SOURCES = ['facebook', 'fb', 'instagram', 'ig', 'meta'];
  var state = window.__nbnMetaOrderAttribution = {
    version: 1, status: 'waiting_for_consent', consented: false,
    capturedFields: [], persisted: false
  };

  function clean(value, limit) {
    return String(value || '').trim().replace(/[\u0000-\u001f\u007f]/g, '').slice(0, limit);
  }
  function cookie(name) {
    var prefix = name + '=', parts = document.cookie ? document.cookie.split(';') : [];
    for (var i = 0; i < parts.length; i += 1) {
      var part = parts[i].trim();
      if (part.indexOf(prefix) === 0) return clean(decodeURIComponent(part.slice(prefix.length)), 255);
    }
    return '';
  }
  function consented() {
    try {
      return Boolean(window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.userCanBeTracked());
    } catch (_) { return false; }
  }
  function isPaid(params) {
    if (params.get('fbclid')) return true;
    var medium = clean(params.get('utm_medium'), 80).toLowerCase();
    var source = clean(params.get('utm_source'), 80).toLowerCase();
    return PAID_MEDIUMS.indexOf(medium) !== -1 || PAID_SOURCES.indexOf(source) !== -1;
  }
  function load() {
    try {
      var value = JSON.parse(sessionStorage.getItem(STORE) || '{}');
      return value && typeof value === 'object' ? value : {};
    } catch (_) { return {}; }
  }
  function save(value) {
    try { sessionStorage.setItem(STORE, JSON.stringify(value)); } catch (_) {}
  }
  function collect() {
    var params = new URLSearchParams(window.location.search || ''), value = load();
    if (isPaid(params)) {
      var fbclid = clean(params.get('fbclid'), 180);
      if (fbclid && !value.fbc) value.fbc = 'fb.1.' + Date.now() + '.' + fbclid;
      for (var i = 0; i < UTM.length; i += 1) {
        var key = UTM[i], current = clean(params.get(key), 180);
        if (current && !value[key]) value[key] = current;
      }
    }
    var fbp = cookie('_fbp');
    if (fbp) value.fbp = fbp;
    save(value);
    return value;
  }
  function attributes(value) {
    var result = {};
    if (value.fbc) result._nbn_meta_fbc = value.fbc;
    if (value.fbp) result._nbn_meta_fbp = value.fbp;
    for (var i = 0; i < UTM.length; i += 1) {
      var key = UTM[i];
      if (value[key]) result['_nbn_' + key] = value[key];
    }
    return result;
  }
  function signature(value) {
    return Object.keys(value).sort().map(function (key) { return key + '=' + value[key]; }).join('&');
  }
  function persist() {
    if (!consented()) { state.status = 'waiting_for_consent'; return Promise.resolve(false); }
    state.consented = true;
    var data = attributes(collect()), fields = Object.keys(data), sig = signature(data);
    state.capturedFields = fields;
    if (!fields.length) { state.status = 'no_paid_attribution'; return Promise.resolve(false); }
    try {
      if (sessionStorage.getItem(SENT) === sig) {
        state.status = 'persisted'; state.persisted = true; return Promise.resolve(true);
      }
    } catch (_) {}
    state.status = 'persisting';
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetch(root + 'cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: data })
    }).then(function (response) {
      if (!response.ok) throw new Error('cart update failed: ' + response.status);
      try { sessionStorage.setItem(SENT, sig); } catch (_) {}
      state.status = 'persisted'; state.persisted = true; return true;
    }).catch(function () { state.status = 'persist_failed'; return false; });
  }
  function attempt() { persist(); }
  document.addEventListener('visitorConsentCollected', attempt);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', attempt);
  else attempt();
  window.setTimeout(attempt, 1500);
  window.setTimeout(attempt, 5000);
}());
